import React, { useState, useEffect, useRef } from "react";
import "./Css/StaffRights.css";
import Header from "./Header";
import Loader from "./Loader.js";
import GreyArrow from "../assets/greyLeftAr.png";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { AiOutlineCamera } from "react-icons/ai";

import cameraicon from "../assets/cameraicon.png";
import {
  handleAphabetsChange,
  check_vaild_save,
  combiled_form_data,
  handleError,
  handleSuccess,
  empty_form,
  handleNumbersChange,
  handleSuccessSession,
  handleNumbersChangeRatting,
  handleIaphabetnumberChange,
  goBack
} from "../CommonJquery/CommonJquery";
import {
  server_post_data,
  save_update_carmodel,
  get_all_carmodel,
  APL_LINK,
} from "../ServiceConnection/serviceconnection.js";
import { useLocation, useParams } from "react-router-dom";
import { Button } from '@mui/material';
import { ArrowLeft } from 'lucide-react';
import Breadcrumb from "../CommonJquery/Breadcrumb.js";

function CarModelAdd() {
  const location = useLocation();
  // const param = useParams();

  const { id } = useParams();

  const currentUrl = location.pathname.substring(1);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [editorDataMainID, setEditorDatMainID] = useState("0");
  const [editStaffData, seteditStaffData] = useState([]);
  const [parentData, setParentData] = useState([]);
  const [subData, setSubData] = useState([]);
  const [designationpagelist, setDesignationPagelist] = useState([]);
  const [error_show, seterror_show] = useState("");
  const [editorData, setEditorData] = useState("");
  const [formVisible, setFormVisible] = useState(false);
  const [testimonials, setshowtestimonial] = useState([]);
  const [testimonialsimage, setshowtestimonialimage] = useState([]);
  const handleSaveChangesdynamic = async (form_data, url_for_save) => {
    let vaild_data = check_vaild_save(form_data);

    if (vaild_data) {
      // if (editorData.length > 0) {
      setshowLoaderAdmin(true);
      let fd_from = combiled_form_data(form_data, null);
      if (id !== undefined) {
        fd_from.append("main_id", id);
      }
      fd_from.append("message", editorData);
      fd_from.append("image_old", testimonialsimage);
      await server_post_data(url_for_save, fd_from)
        .then((Response) => {
          
          setshowLoaderAdmin(false);
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            handleSuccessSession(Response.data.message, "/Car_Types");
            setFormVisible(false);
            empty_form(form_data);
          }
        })
        .catch((error) => {
          console.log(error);
          setshowLoaderAdmin(false);
        });
      // } else {
      //   seterror_show("Please Fill The Mandatory Information");
      // }
    }
  };
  useEffect(() => {
    if (id !== undefined) {
      master_data_get();
    }
  }, []);

  const master_data_get = async () => {
    console.log(testimonialsimage);
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("call_id", id);
    fd.append("flag", 3);
    await server_post_data(get_all_carmodel, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          if (Response.data.message.data.length > 0) {
            setshowtestimonial(Response.data.message.data[0]);
            setshowtestimonialimage(Response.data.message.data[0].image);
            let image_link = Response.data.message.image_link;
            setImage(
              APL_LINK + image_link + Response.data.message.data[0].image
            );
            setIsImageUploaded(true);
          }
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        // handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const handleEditorChange = (event, editor) => {
    setEditorData(editor.getData());
  };
  const [image, setImage] = useState(null);
  const [isImageUploaded, setIsImageUploaded] = useState(false);
  const fileInputRef = useRef(null);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
        setIsImageUploaded(true);
      };
      reader.readAsDataURL(file);
    }
  };
  const triggerFileInput = () => {
    fileInputRef.current.click();
  };
  return (
    <div className="dashboard">
      {showLoaderAdmin && <Loader />}
      <div className="dashboard_container">
        <Header />

        <div className="page_content">
          <div className="page_content_container">
            <div className="pageCntn_head" style={{ top: "0px" }}>
              <div className="pageNameDiv">
              <Breadcrumb
                  items={[
                    { label: "View Car Type", path: "/Car_Types" },
                    {
                      label: location.pathname.includes("/Edit_carmodel") ? "View Car Type" : "Add Car Models",
                      path: location.pathname,
                    },
                  ]}
                />
                {/* <p>
                  {location.pathname.includes("/Edit_carmodel") ? (
                    <p>View Car Type</p>
                  ) : (
                    <p>Add Car Models</p>
                  )}
                </p> */}
                <img src={GreyArrow} alt="Rapid Car Leasing" />
              </div>
              <Button
                onClick={goBack}
                startIcon={<ArrowLeft size={17} style={{ marginBottom: "2px" }} />}
                className="Back_bttn_page"
              >
                Back
              </Button>
            </div>

            <div className="page_body">
              <div className="create_staffRights">
                <form className="createRightsForm" id="createRightsForm">
                  <div className="row m-0">
                    <div className="personalForm">
                      <div className="staffForm_container">
                        <div className="row m-0"  >
                          <div className="col-md-12" >
                            {" "}
                            <div
                              className={`imageViewConter ${isImageUploaded ? "uploaded" : ""
                                }`}
                              onClick={triggerFileInput} style={{ cursor: "pointer" }}
                              title="Image Size: 200x115 px"
                            >
                              {isImageUploaded ? (
                                <img
                                  src={image}
                                  alt="Uploaded"
                                  onClick={triggerFileInput}
                                  style={{ cursor: "pointer" }}
                                />
                              ) : (
                                <img
                                  src={cameraicon}
                                  alt="cameraicon"
                                  className="cameraIcon"
                                  onClick={triggerFileInput}
                                ></img>
                              )}
                              <input
                                type="file"
                                ref={fileInputRef}
                                accept="image/*"
                                name="image"
                                style={{ display: "none" }}
                                onChange={handleImageUpload}
                              />
                            </div>
                            <label className="imngTaggLine1">Upload Image</label>
                            <span style={{ fontSize: "12px", color: "red", }}>
                              Upload an Image of Size 400x200 px
                            </span>
                          </div>

                          <div className="col-md-12 mt-2">
                            <div className="inpContainer">
                              <label className="no_prsnl_id">
                                Description
                                <span>*</span>
                              </label>
                              <div>
                                <textarea
                                  name="name"
                                  defaultValue={testimonials.name || ""} // Use `value` instead of `defaultValue` for controlled components
                                  placeholder="Enter your name"
                                  minLength={3}
                                  maxLength={500}
                                  className=" trio_mandatory  form-control"
                                  onChange={(e) =>
                                    handleIaphabetnumberChange(e)
                                  } // Ensure correct event handler usage
                                />
                                <span className="condition_error"></span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="createRightBtnDiv mb-5">
                          <button
                            className="btn btn-primary Create_Designation_Btn btnSave"
                            type="button"
                            onClick={() =>
                              handleSaveChangesdynamic(
                                "createRightsForm",
                                save_update_carmodel
                              )
                            }
                          >
                            {location.pathname.includes("/Edit_carmodel")
                              ? "Update"
                              : "Add"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CarModelAdd;
